<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        
        <Toolbar class="p-mb-4">
          <template slot="left">
            <Button
              label="New Contact"
              icon="pi pi-plus"
              class="p-button-success p-mr-2"
              @click="openNew"
            />
            <Button
              icon="pi pi-fw pi-cog"
              class="p-mx-1"
              @click="openColumnsSelection()"
            />
          </template>

          <template slot="right">
            <ToggleButton 
              v-model="showOnlyActive" 
              onLabel="Show all contacts" 
              offLabel="Show active contacts only" 
              style="width: 14em;" 
            />
            <span class="p-input-icon-left" style="padding-left:10px;">
              <i class="pi pi-search" style="padding-left:12px;"/>
              <InputText
                v-model="filters['global']"
                placeholder="Global Search"
              />
            </span>
          </template>
        </Toolbar>

      </div>
    </div>

    <div
      :style="{ 'width': '100%' }"
    >
      <ContactTable
        :key="contactsTableKey"
        :dbView="dbView"
        :colSelectedFieldsForTable="colSelectedFieldsForTable"
        :colSelectedFields="colSelectedFields"
        :dbViewFields="dbViewFields"
        :contacts="duplicateContacts"
        :loading="loading"
        @edit-contact=editContact
        @delete-contact="deleteContact"
        @reloadCols="reloadCols"
      />
    </div>
    
    <ContactForm
      :reload="reloadContactForm"
      :contactToEdit="contactToEdit"
      :contactForm="contactDialog"
      :disabledArr="contactDisabledArr"
      @hide-form-dialog=hideDialog
      @submit-contact-form=savedContact
    />

    <DuplicateDialog
      :key="duplicateDialogKey"
      :duplicateDialog="duplicateDialog"
      :contact="duplicateContact"
      @hide-duplicate-dialog=hideDuplicateDialog
      @submit-duplicate-form=saveDuplicate
    />

    <ColumnSelection
      :columnSelectionDialog="columnSelectionDialog"
      :dbView="dbView"
      :dbViewFields="dbViewFields"
      :selectionToEdit="colSelectedFields"
      :reloadComponent="reloadColumnSelectionComponent"
      :resettingColumns="resettingColumns"
      @close="columnSelectionDialog = false"
      @colSaved="colSaved()"
      @resetCols="resetCols"
    />

  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";
import FiltersService from "@/service/FiltersSerice";
import ContactService from "@/service/ContactService";

import ContactForm from '../../universalComponents/contact/contactForm'
import DuplicateDialog from '../../universalComponents/contact/duplicateDialog'
import ContactTable from '../../universalComponents/contact/ContactsTable'
import ColumnSelection from '../../universalComponents/columnSelection/ColumnSelection'

export default {
  props: ["customer"],
  components: {
    ContactForm,
    DuplicateDialog,
    ContactTable,
    ColumnSelection
  },
  data() {
    return {
      filtersService: new FiltersService(),
      contactService: new ContactService(),
      dbView: 2,
      contactDisabledArr: [],
      contactToEdit: {},
      reloadContactForm: 0,
      showOnlyActive: false,
      contacts: null,
      duplicateContacts: null,
      contactDialog: false,
      selectedContacts: null,
      filters: {},
      loading: true,
      expandedRows: [],
      duplicateDialogKey1: 0,
      duplicateToSend: {},
      duplicateContact: {},
      duplicateDialog: false,
      contactsTableKey1: 0,
      dbViewFields: [],
      colSelectedFields: [],
      colSelectedFieldsForTable: [],
      columnSelectionDialog: false,
      reloadColumnSelectionComponent: 0,
      resettingColumns: false,
    };
  },
  computed: {
    myPermissions() {
      return this.$store.getters['auth/getUserPermissions']
    },
    duplicateDialogKey: {
      set() {
        this.duplicateDialogKey1++
      },
      get() {
        return 'duplicateDialogKey-' + this.duplicateDialogKey1.toString()
      }
    },
    contactsTableKey: {
      set() {
        this.contactsTableKey1++
      },
      get() {
        return 'contactsTableKey-' + this.contactsTableKey1.toString()
      }
    }
  },
  customerService: null,
  created() {
    this.customerService = new CustomerService();
  },
  mounted() {
    this.getColumnSelection()

    this.getDBViewFields()

    this.getCustomerContacts()
  },
  watch: {
    colSelectedFields(val) {
      this.$store.dispatch(`commons/columnsSelection${this.dbView}`, val)
      this.setupColumns()
    },
    colSelectedFieldsForTable(val) {
      this.contactsTableKey++
    },
    dbViewFields(val) { // toggles between default view and user saved view
      
      if (this.colSelectedFieldsForTable.length < 1) {
        this.colSelectedFieldsForTable = val.filter(a => a.defView)
      }
      // this.colSelectedFieldsForTable.forEach(a => 
    },
    duplicateContacts(val) {
      if (val && val[0])
        this.contactsTableKey++
    },
    duplicateDialog(val) {
      this.duplicateDialogKey++
    },
    contactDialog(val) {
      this.reloadContactForm++
    },
    showOnlyActive(val) {
      if (val) {
        this.duplicateContacts = this.contacts.filter(contact => contact.active === true)
      } else {
        this.duplicateContacts = this.contacts
      }
    }
  },
  methods: {
    resetCols() {
      this.resettingColumns = true

      this.filtersService
        .resetColumns(this.dbView)
        .then(data => {
          this.resettingColumns = false
          this.columnSelectionDialog = false
          this.colSelectedFields = data
          this.getDBViewFields()
        })
        .catch(error => {
          this.resettingColumns = false
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error while reseting columns`,
            life: 5000,
          })
        })
    },
    colUpdated(obj) {
      if (obj) {
        var id = obj.id, width = obj.width
        // 
        let a = this.colSelectedFields.findIndex(b => b.id === id)
        if (a >= 0 && this.colSelectedFields[a]) {
          this.colSelectedFields[a].width = width
        }
      }
    },
    colSaved() {
      
      this.columnSelectionDialog = false

      this.getColumnSelectionByHard()
      this.getDBViewFields()
    },
    openColumnsSelection() {
      this.columnSelectionDialog = true
      this.reloadColumnSelectionComponent++
    },
    getDBViewFields() {
      this.filtersService
        .getDBViewFields(this.dbView)
        .then(data => {
          this.dbViewFields = data
          
        })
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer DB view fields",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          })
        })
    },
    reloadCols() {
      this.getColumnSelectionByHard()
      this.getDBViewFields()
    },
    setupColumns() {
      if (this.colSelectedFields && this.colSelectedFields[0] && this.columnSelectionDialog) {
        this.reloadColumnSelectionComponent++
      }

      let a = []
      this.colSelectedFields.forEach(b => {
        // 
        let c = a.find(d => d.dbField === b.dbField.dbField)
        // 
        if (!a[b.colOrder - 1] && !c) {
          a[b.colOrder - 1] = { 
            ...b.dbField,
            defWidth: b.width
          }
        }
      })
      
      if (a.length) {
        this.colSelectedFieldsForTable = a
      }
    },
    getColumnSelectionByHard() {
      this.filtersService
        .getColumnSelectionByHard(this.dbView)
        .then(data => {
          
          this.colSelectedFields = data
        })
        .catch(err => {
          

          if (err.response.status === 500) {
            // Default view
            
            this.defaultView = true
          }
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "currentUserViewFields/{dbView}"'
          })
        })
    },
    getColumnSelection() {
      this.filtersService
        .getColumnSelection(this.dbView)
        .then(data => {
          
          this.colSelectedFields = data
        })
        .catch(err => {
          

          if (err.response.status === 500) {
            // Default view
            
            this.defaultView = true
          }
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "currentUserViewFields/{dbView}"'
          })
        })
    },
    getButtons(data) { 
      let buttons = []

      buttons.push(
        {
          label: 'Delete',
          icon: 'pi pi-trash',
          command: () => {
            this.confirmDeleteContact(data)
          }
        }
      )
      return buttons
    },
    saveDuplicate() {
      this.duplicateDialog = false

      this.duplicateToSend.customer = this.$route.params.custid

      this.customerService
        .saveDuplicateContactDB(this.duplicateToSend)
        .then(response => {
          
          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Contact Saved",
              detail: `New contact was saved successfully`,
              life: 5000,
            });
            
            this.getCustomerContacts()
          }
        })
        .catch(err => {
          
                
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while saving customer",
            life: 5000,
          })
        })
    },
    hideDuplicateDialog() {
      this.duplicateDialog = false
    },
    getCustomerContacts() {
      this.contacts = []
      
      this.customerService
        .getCustomerContacts(this.$route.params.custid)
        .then((data) => {
          this.contacts = data
          this.duplicateContacts = data
          this.loading = false;
        })
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer contacts",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "customerContacts/{customerId}"'
          })
        })
    },
    openNew() {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'AddNewContact');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new contact",
            life: 5000,
          })
        } else if (permission.permissionLevel === 1) {
            this.contactToEdit = {};
            this.contactToEdit.customerId = this.$route.params.custid
            this.contactToEdit.canEmail = true;
            this.contactToEdit.canCall = true;
            this.contactToEdit.canMail = true;
            this.contactToEdit.active = true;
            if (this.contacts) {
              this.contactToEdit.keyContact = false;
            } else {
              this.contactToEdit.keyContact = true;
            }
            this.contactDisabledArr = [
              'Customer'
            ]
            this.contactDialog = true;
        }
      }
    },
    deleteContact(contact) {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'DeleteCustomer');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to delete a contact",
            life: 5000,
          })
        } else if (permission.permissionLevel === 1) {
            if (contact && contact.contactId) {
              this.contactService
                .deleteContact(contact.contactId)
                .then(data => {
                  this.getCustomerContacts()

                  this.$toast.add({
                    severity: "success",
                    summary: "Deleted successfully.",
                    detail: `Contact ${contact.firstName} ${contact.lastName} has been deleted successfully'`,
                    life: 5000,
                  })
                })
                .catch(error => {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: `Contact could not be deleted. Make sure there are no related records such as Tasks, Events or Quotations linked to this contact. Also make sure the contact is not the key contact for '${contact.custName ? contact.custName : ''}'`,
                    life: 10000,
                  })
                })
            }
        }
      }
    },
    editContact(contact) {
      this.contactToEdit = contact
      this.contactDialog = true;
    },
    confirmDeleteSelected() {
      //this.deleteProductsDialog = true;
    },
    hideDialog() {
      this.contactDialog = false;
    },
    savedContact({ contact, duplicateContact, duplicateToSend }) {
      
      this.contactToEdit = {}
      this.contactDialog = false
      if (duplicateToSend) {
        this.duplicateToSend = duplicateToSend
        this.duplicateContact = duplicateContact
        this.duplicateDialog = true
      }
      this.getCustomerContacts()
    }
  }
};
</script>

<style scoped lang="scss">
.p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

.p-datatable.p-datatable-customers {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  .p-datatable {
    &.p-datatable-customers {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        border-bottom: 1px solid var(--layer-2);

        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
